import React, { useContext, useState } from 'react';
import Button from '../../../../../../components/button';
import Input from '../../../../../../components/input';
import { Modal } from '../../../../../../components/modal';
import GlobalContext from '../../../../../../context/globalContext';

interface IEditGiftCard {
  title: string;
  defaultValue: string;
}

const EditGiftCard = ({ title, defaultValue }: IEditGiftCard) => {
  const [brandName, setBrandName] = useState<string>('');
  const { giftCardInputs, setGiftCardInputs } = useContext(GlobalContext);
  const [time, setTime] = useState<string>('');
  const [open, setOpen] = useState(false);

  const save = () => {
    title === 'Brand Name'
      ? setGiftCardInputs({ ...giftCardInputs, brandName: brandName })
      : setGiftCardInputs({ ...giftCardInputs, processingTime: time });
    setOpen(false);
  };

  return (
    <div>
      <div className="text-blue cursor-pointer" onClick={() => setOpen(true)}>
        Change
      </div>

      <Modal
        padding={true}
        isVisible={open}
        center
        close={setOpen}
        title={title}
        header={true}
        width="medium"
        showFooter
        footer={
          <div className="flex justify-end">
            <Button onClick={save}>Save Changes</Button>
          </div>
        }
      >
        <div>
          <Input
            defaultValue={defaultValue}
            onChange={(e) => {
              title === 'Brand Name'
                ? setBrandName(e.target.value)
                : setTime(e.target.value);
            }}
          />
        </div>
      </Modal>
    </div>
  );
};

export default EditGiftCard;
